let router = {
    home: "首页",
    company: {
        title: "企业管理",
        title1: "企业列表",
    },
    application: {
        title: "应用管理",
        title1: "应用列表",
    },
    device: {
        title: "设备管理",
        title1: "设备列表",
    },
    fota: {
        title: "FOTA",
        title1: "固件管理",
        title2: "升级管理",
    },
    log: {
        title: "日志管理",
        title1: "管理员日志",
    },
    message: {
        title: "消息管理",
        title1: "播报记录",
    },
    org: {
        title: "机构管理",
        title1: "组织机构",
    },
    setting: {
        title: "配置管理",
        title1: "基本配置",
    },
    template: {
        title: "模板管理",
        title1: "语音模板",
        title2: "打印模板",
    },
    user: {
        title: "管理员",
        title1: "管理员列表",
    },
}

export default router
